export default {
  enums: [
    { id: 'PAYMENT_AFTER_EMISSION' },
    { id: 'PAYMENT_AFTER_APPLYING' },
  ]
};